export class ScoreBoard {
  constructor(
    public home: string,
    public away: string,
    public date: string | any,
    public pitcherHome: string,
    public pitcherAway: string,
  ) {}
}
